import { FC } from 'react';
import {
  Container,
  ProgressWrapper,
  UploadErrorWrapper,
  UploadFailText,
  Wrapper,
  IconCenter,
  // IconPulse,
  UploadCompleteText,
  ThanksText,
} from './UploadProgressBar.styles';
import { Box } from '@mui/system';
import { useTypedSelector } from '../../../store/store';
import { UploadProcessStep } from '../../../store/storeModels';
import { CircularProgress, useTheme } from '@mui/material';

import { UploadProgressStrings } from '../../localization/en';
import { SuccessUploadIcon } from '../../assets/SuccessUploadIcon';
// import { WeakWifiIcon } from '../../assets/WeakWifiIcon';
import { useBlockNavigation } from '../../hooks/useBlockNavigation';
import { RouteLeavingModal } from '../RouteLeavingModal/RouteLeavingModal';
import { UploadPausedIcon } from '../../assets/UploadPausedIcon';
// import { useLocation } from 'react-router-dom';
// import { AppRoutes } from '../../constants/routes';
import { ArrowUpload } from '../../assets/ArrowUpload';

interface Props {
  forceShowUploadComplete?: boolean;
}

export const UploadProgressBar: FC<Props> = ({ forceShowUploadComplete }) => {
  const { currentStep, uploadingProgress, isUploadError } = useTypedSelector((state) => state.upload);
  const isUploadComplete = currentStep === UploadProcessStep.Uploaded || forceShowUploadComplete;
  const theme = useTheme();
  // const { pathname } = useLocation();
  // const isSharePage = pathname.includes(AppRoutes.Share);
  const { confirmNavigation, cancelNavigation, pendingNavigation } = useBlockNavigation({
    shouldBlock: !isUploadComplete || false,
  });
  return (
    <Container>
      <RouteLeavingModal
        open={!!pendingNavigation}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
        titleText="title text"
        contentText="content text"
      />
      <ProgressWrapper
        sx={{
          border: isUploadError ? `1.5px solid #ED2E38` : `1.5px solid ${theme.palette.primary.main}`,
        }}
      >
        {!isUploadComplete ? (
          isUploadError ? (
            <UploadErrorWrapper>
              <UploadPausedIcon color="#ED2E38" />
              <Box ml="16px">
                <UploadFailText>{UploadProgressStrings.VideoUploadFailed}</UploadFailText>
                {/* <ThanksText>{UploadProgressStrings.WeakConnectivityDetected}</ThanksText> */}
              </Box>
            </UploadErrorWrapper>
          ) : (
            <Box display={'flex'}>
              <Wrapper>
                <CircularProgress
                  variant="determinate"
                  value={100}
                  size={44}
                  sx={{
                    position: 'absolute',
                    top: 3,
                    left: 0,
                    color: '#EAECF0',
                    zIndex: 0,
                  }}
                />
                <CircularProgress
                  variant={!uploadingProgress ? 'indeterminate' : 'determinate'}
                  value={uploadingProgress}
                  sx={{
                    color: '#4F49E1',
                    marginRight: '19px',
                  }}
                  size={44}
                />
                <IconCenter>
                  <ArrowUpload className="" style={{ animation: 'inherit' }} />
                </IconCenter>
              </Wrapper>
              <Box display="block">
                <UploadCompleteText $color="#2D11AD">{UploadProgressStrings.UploadInprogress}</UploadCompleteText>
                <ThanksText sx={{ color: '#475467' }}>{UploadProgressStrings.KeepThisTabOpen}</ThanksText>
              </Box>
            </Box>
          )
        ) : (
          <>
            <SuccessUploadIcon color={'#4F49E1'} />
            <Box ml="16px">
              <UploadCompleteText $color="#4F49E1">
                {UploadProgressStrings.VideoUploadCompleteShare}
              </UploadCompleteText>
              <ThanksText>{UploadProgressStrings.Weappreciate}</ThanksText>
            </Box>
          </>
        )}
      </ProgressWrapper>
    </Container>
  );
};
